<div #resizeContainer class="content" (click)="$event.stopPropagation()" [style.height.px]="height" [style.width.px]="width">
    <!-- Reduced margin-bottom here to tighten space between "- Filter" and "Search" -->
    <div class="header">
        <mat-icon style="color: #1ea9d3">sort</mat-icon>
        <span style="color: #1ea9d3">Summary Fields</span>
        <button class="filter-close-button" mat-icon-button (click)="onCloseFilter()">X</button>
    </div>
    <!-- <div>
        <mat-select style="width: 70%;" placeholder="Select Data Farm" [(ngModel)]="source" (selectionChange)="onChangeSource()">
            <mat-option *ngFor="let col of sources" [value]="col">{{col}}</mat-option>
        </mat-select>
    </div> -->
    <div style="background-color: #000000;" class="matselection" style="padding: 0;">
        <!-- Search bar with no bottom margin and no extra padding -->
        <mat-form-field class="inputsearch">
            <!-- <mat-label>Search</mat-label> -->
            <input matInput [formControl]="search" placeholder="Search">
        </mat-form-field>
        
        <!-- Selection list with reduced margin-top and no padding -->
        <mat-selection-list (selectionChange)="onFilterItemSelected($event)" style="margin-top: 0; padding: 0;">
            <cdk-virtual-scroll-viewport [itemSize]="5" class="example-viewport">
                <mat-list-option checkboxPosition="before" *cdkVirtualFor="let item of filteredOptions | async; templateCacheSize: 0" 
                    [value]="item.value" [(selected)]="item.isSelected" [disabled]="item.isDisabled" [ngClass]="item.isDisabled ? 'disablematselection' : item.color">{{ item.text }}
                </mat-list-option>
            </cdk-virtual-scroll-viewport>
        </mat-selection-list>
    </div>

    <div class="footer">
        <button mat-raised-button color="primary" (click)="onApplyFilter()">Select</button>
        <button mat-raised-button (click)="onClearFilter()" style="margin-left: 5px">Cancel</button>
    </div>
</div>
